// extracted by mini-css-extract-plugin
module.exports = {"icon_color":"ChartLoadingIcon_icon_color__IymTB"};